import useSWR, { mutate } from "swr";
import axios from "axios";
import moment from "moment";

export function UseTodayReports() {
  // SWR: Retrieve Today's Reports (Campaigns)
  const { isValidating: REPORTS_LOADING, data: REPORTS } = useSWR(
    "/api/report/report-today/aureas",
    async (url) => {
      const today = moment().format("YYYY-MM-DD");

      return await axios
        .post(url, {
          date_from: today,
          date_to: today,
          owner: "Aureas",
        })
        .then((res) => res.data.full_reports);
    }
    // { revalidateIfStale: false, revalidateOnFocus: false }
  );

  return {
    REPORTS_LOADING,
    REPORTS,
  };
}

export function UpdateScalingStatus(
  setAlert,
  username,
  campaign_id,
  scaling_status
) {
  // SWR: Update Specific Today's Report (Campaign)
  mutate("/api/report/report-today/aureas", async (REPORTS) => {
    // console.log("update campaign", username, campaign_id, scaling_status);

    // Update Scaling Status in Campaigns Database
    const res = await axios.put(
      `/api/checkout_db/campaigns/scaling_status/${campaign_id}`,
      {
        scaling_status,
        username,
      }
    );
    const new_campaign = res.data;

    if (new_campaign) {
      setAlert("Scaling Status Updated.", "success");

      // Mutate REPORTS
      const existing_reports = REPORTS.filter(
        (report) => report.campaign_id !== new_campaign.campaign_id
      );

      const updated_reports = REPORTS.find(
        (report) => report.campaign_id === new_campaign.campaign_id
      );

      return [
        ...existing_reports,
        { ...updated_reports, scaling_status: new_campaign.scaling_status },
      ];
    }
  });
}
